import { Component, OnInit } from '@angular/core';
import { AccountStatementDetails } from '../../../types/interface.types';
import { CondomanagerService } from '../../../services/condomanager.service';

@Component({
  selector: 'account-balance-modal',
  templateUrl: './account-balance-modal.component.html',
  styleUrls: ['./account-balance-modal.component.scss']
})
export class AccountBalanceModalComponent implements OnInit {

  modalWidth: number = 800;

  private accountStatementsList: AccountStatementDetails[];

  /**
   * Date interval
   */
  dateFrom: Date = null;
  dateTo: Date = null;

  constructor(
      private condomanagerService: CondomanagerService
  ) { }

  ngOnInit() {
    this.accountStatementsList = this.condomanagerService.accountStatementModalDetails;
  }

  /**
   * Closes modal
   */
  closeModal() {
    this.condomanagerService.accountStatementModalDetails = null;
  }

  /**
   * Returns last operation
   */
  get lastUpdate(): AccountStatementDetails {
    return this.accountStatementsList[0];
  }

  /**
   * Returns filtered account statements
   */
  get accountStatements(): AccountStatementDetails[] {
    let result = this.accountStatementsList;

    if(this.dateFrom) {
      result = result.filter(item => getDate(item.date) >= getDate(this.dateFrom));
    }

    if(this.dateTo) {
      result = result.filter(item => getDate(item.date) <= getDate(this.dateTo));
    }

    // resets hours for date comparison
    function getDate(date: Date | string): Date {
      if(typeof date === 'string') {
        date = new Date(date);
      }

      date.setHours(0, 0, 0, 0);

      return date;
    }

    return result;
  }

  /**
   * Returns balance for selected period
   */
  get total(): number {
    return this.accountStatements
        .map(item => item.amount)
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/account-balance-modal/account-balance-modal.component.ts